import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation } from 'react-router-dom';
import Select from 'react-select';
import axios from "axios";
import './EmployeeCreationForm.css';
import DatePicker from 'react-datepicker';
import { getGenders, getQualifications, getDesignations, createEmployee, updateEmployee, getUsers } from "../../../../../services/employeeCreationService";
// import {validateEmail,validateMobile,validateAadhaar,validateAge,validatePastDate} from "../../../../../utils/validation";
import { validateEmail, validateMobile, validateAadhaar, validateAge, validatePastDate, capitalizeFirstLetter } from "../../../../../utils/validations";
import { selectStyles } from "../../../../../assets/Styles/selectStyle";
//import { set } from "react-datepicker/dist/date_utils";
const EmployeeCreationForm = () => {
    const storedUser = JSON.parse(localStorage.getItem("user"));
    const Navigate = useNavigate();
    const location = useLocation();
    const employeeToEdit = location.state?.employee || null;
    const [qualifications, setQualifications] = useState([]);
    const [selectedQualification, setSelectedQualification] = useState(null);
    const [designations, setDesignations] = useState([]);
    const [selectedDesignation, setSelectedDesignation] = useState(null);
    const [users, setUsers] = useState([]);
    const [selectedUserId, setSelectedUserId] = useState(null);
    const [isEditMode, setIsEditMode] = useState(!!employeeToEdit);

    const effectRan = useRef(false);


    const [employeeCreationData, setEmployeeCreationData] = useState({
        firstName: "",
        lastName: "",
        gender: "",
        dateOfBirth: "",
        contactNumber: "",
        emailAddress: "",
        jobPosition: "",
        yearsOfExp: "",
        aadharNumber: "",
        qualification: "",
        interviewDoneBy: "",
        interviewDate: "",
    });
    const [initialData, setInitialData] = useState(null);
    const [hasChanges, setHasChanges] = useState(false);
    const [loading, setLoading] = useState(false);
    const [errors, setErrors] = useState({
        firstName: '',
        lastName: '',
        gender: '',
        dateOfBirth: '',
        interviewDate: '',
        contactNumber: '',
        emailAddress: '',
        jobPosition: '',
        qualification: '',
        interviewDoneBy: '',
        aadharNumber: '',
    });
    const [genders, setGenders] = useState([]);
    const [isFormValid, setIsFormValid] = useState(false);
    const [isFocused, setIsFocused] = useState({ gender: false, dateOfBirth: false, interviewDate: false });
    const [apiError, setApiError] = useState('');
    const [showSaveSuccess, setShowSaveSuccess] = useState(false);
    const [showDialog, setShowDialog] = useState(false);
    const [isSaved, setIsSaved] = useState(false);
    const [successMessage, setSuccessMessage] = useState("");
    const [savedResponse, setSaveResponse] = useState("");

    const [mobileNumberError, setMobileNumberError] = useState('');
    const [emailError, setEmailError] = useState('');
    const [aadharNumberError, setAadharNumberError] = useState('');

    // Calculate minimum DOB (18 years ago from today)
    const today = new Date();
    const minDOB = new Date();
    minDOB.setFullYear(today.getFullYear() - 18); // Set to 18 years ago
    const minDate = new Date(1965, 0, 1).toISOString().split('T')[0];
    const maxDOB = minDOB.toISOString().split('T')[0]; // Max DOB is 18 years ago
    const maxDate = today.toISOString().split('T')[0]; // For interview date

    // Initialize form data and store initial data for comparison
    useEffect(() => {
        console.log("employeeToEdit:", employeeToEdit);
        if (employeeToEdit) {
            const initial = {
                firstName: employeeToEdit.firstName || "",
                lastName: employeeToEdit.lastName || "",
                gender: employeeToEdit.gender?.id || "",
                dateOfBirth: employeeToEdit.dob || "",
                contactNumber: employeeToEdit.mobile || "",
                emailAddress: employeeToEdit.email || "",
                jobPosition: employeeToEdit.jobPosition?.id || "",
                qualification: employeeToEdit.qualification?.id || "",
                interviewDoneBy: employeeToEdit.interviewDoneBy?.employeeloginId || "",
                interviewDate: employeeToEdit.interviewCompletedDate || "",
                yearsOfExp: employeeToEdit.yearsOfExperience || 0,
                aadharNumber: employeeToEdit.aadhaarNumber || "",
            };
            console.log("Initial yearsOfExp:", initial.yearsOfExp); // Debug log
            setEmployeeCreationData(initial);
            setSelectedQualification(initial.qualification);
            setSelectedDesignation(initial.jobPosition);
            setSelectedUserId(initial.interviewDoneBy);
            setInitialData(initial);
            setIsSaved(false);
        }
    }, [employeeToEdit]);

    // Fetch genders
    useEffect(() => {
        const fetchGenders = async () => {
            try {
                //  const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/genders`);
                const data = await getGenders();
                //const data = response.data;
                if (Array.isArray(data)) {
                    setGenders(data.map(item => ({
                        value: item.id,
                        label: item.gender,
                    })));
                } else {
                    console.error('Invalid response format: genders should be an array');
                }
            } catch (error) {
                console.error('Error fetching genders:', error);
            }
        };
        if (effectRan.current === false) {
            fetchGenders();
        }
        return () => {
            effectRan.current = true;
        }

    }, []);

    // Fetch qualifications
    useEffect(() => {
        const fetchQualifications = async () => {
            try {
                const data = await getQualifications();
                if (Array.isArray(data)) {
                    setQualifications(
                        data.map((q) => ({
                            value: q.id,
                            label: q.qualificationName,
                        }))
                    );
                } else {
                    console.error("Invalid response: qualifications should be an array");
                }
            } catch (err) {
                console.error("Error fetching qualifications:", err);
            }
        };

        if (effectRan.current === false) {
            fetchQualifications();
        }
        return () => {
            effectRan.current = true;
        }
    }, []);

    // Fetch designations
    useEffect(() => {
        const fetchDesignation = async () => {
            try {
                const data = await getDesignations();
                if (Array.isArray(data)) {
                    const sortedData = data
                     .sort((a, b) => a.designationName.localeCompare(b.designationName))
                     .map((d) => ({
                        value: d.id,
                        label: d.designationName,
                    }));
                   setDesignations(sortedData);
                    // setDesignations(
                    //     data.map((d) => ({
                    //         value: d.id,
                    //         label: d.designationName,
                    //     }))
                    // );
                } else {
                    console.error("Invalid response: designations should be an array");
                }
            } catch (err) {
                console.error("Error fetching designation:", err);
            }
        };
        if (effectRan.current === false) {
            fetchDesignation();
        }
        return () => {
            effectRan.current = true;
        }

    }, []);

    // Fetch users
    useEffect(() => {
        const fetchUsers = async () => {
            try {
                //  const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/list`);
                const data = await getUsers();
                if (Array.isArray(data)) {
                    setUsers(
                        data.map(user => ({
                            value: user.employeeloginId,
                            label: user.fullName,
                        }))
                    );
                } else {
                    console.error("Invalid response: users should be an array");
                }
            } catch (error) {
                console.error("Error fetching users:", error);
            }
        };
        // if (effectRan.current === false) {
        fetchUsers();
        // }
        // return () => {
        //     effectRan.current = true;
        // }

    }, []);

    // Check for changes in form data
    useEffect(() => {
        if (isEditMode && initialData) {
            const hasDataChanged = Object.keys(employeeCreationData).some(
                key => employeeCreationData[key] !== initialData[key]
            );
            setHasChanges(hasDataChanged);
        }
    }, [employeeCreationData, initialData, isEditMode]);

    // Validate form
    useEffect(() => {
        const {
            firstName = '',
            lastName = '',
            dateOfBirth = '',
            contactNumber = '',
            emailAddress = '',
            jobPosition = '',
            gender = '',
            qualification = '',
            interviewDoneBy = '',
            interviewDate = '',
            aadharNumber = '',
        } = employeeCreationData || {};

        // Format date
        const formattedDateOfBirth =
            typeof dateOfBirth === "string"
                ? dateOfBirth.split("T")[0]
                : dateOfBirth instanceof Date
                    ? dateOfBirth.toISOString().split("T")[0]
                    : "";

        // Validate age
        let isAgeValid = true;
        if (formattedDateOfBirth) {
            const dob = new Date(formattedDateOfBirth);
            const ageDiff = today.getFullYear() - dob.getFullYear();
            const monthDiff = today.getMonth() - dob.getMonth();
            const dayDiff = today.getDate() - dob.getDate();
            const age = monthDiff < 0 || (monthDiff === 0 && dayDiff < 0) ? ageDiff - 1 : ageDiff;
            isAgeValid = age >= 18;
        }

        // Final validation
        const isValid =
            firstName.trim() !== "" &&
            lastName.trim() !== "" &&
            formattedDateOfBirth.trim() !== "" &&
            isAgeValid &&
            gender !== "" &&
            qualification !== "" &&
            interviewDoneBy !== "" &&
            interviewDate !== "" &&
            aadharNumber.trim() !== "" &&
            validateMobile(contactNumber) &&
            validateEmail(emailAddress) &&
            jobPosition !== "" &&
            validateAadhaar(aadharNumber) &&
            !errors.aadharNumber; // prevent submission if Aadhaar duplication error exists

        setIsFormValid(isValid);
    }, [employeeCreationData, errors.aadharNumber]);

    const handleInputChange = (eOrOption, fieldName) => {
        let value;

        if (eOrOption && eOrOption.target) {
            const { name, value: fieldValue } = eOrOption.target;
            value = fieldValue;

            if (name === 'dateOfBirth' && value) {
                value = new Date(value).toISOString().split('T')[0];
                // Validate age
                const dob = new Date(value);
                const ageDiff = today.getFullYear() - dob.getFullYear();
                const monthDiff = today.getMonth() - dob.getMonth();
                const dayDiff = today.getDate() - dob.getDate();
                const age = monthDiff < 0 || (monthDiff === 0 && dayDiff < 0) ? ageDiff - 1 : ageDiff;

                if (age < 18) {
                    setErrors(prev => ({
                        ...prev,
                        dateOfBirth: 'Employee must be at least 18 years old.',
                    }));
                } else {
                    setErrors(prev => ({
                        ...prev,
                        dateOfBirth: '',
                    }));
                }
            }

            setEmployeeCreationData(prev => ({
                ...prev,
                [name]: value,
            }));

            if (name !== 'dateOfBirth') {
                setErrors(prev => ({
                    ...prev,
                    [name]: '',
                }));
            }

            if (name === "lastName") {
                localStorage.setItem("lastName", value);
            }
        } else {
            value = eOrOption ? eOrOption.value : '';

            if (fieldName === 'dateOfBirth' && value) {
                value = new Date(value).toISOString().split('T')[0];
                // Validate age
                const dob = new Date(value);
                const ageDiff = today.getFullYear() - dob.getFullYear();
                const monthDiff = today.getMonth() - dob.getMonth();
                const dayDiff = today.getDate() - dob.getDate();
                const age = monthDiff < 0 || (monthDiff === 0 && dayDiff < 0) ? ageDiff - 1 : ageDiff;

                if (age < 18) {
                    setErrors(prev => ({
                        ...prev,
                        dateOfBirth: 'Employee must be at least 18 years old.',
                    }));
                } else {
                    setErrors(prev => ({
                        ...prev,
                        dateOfBirth: '',
                    }));
                }
            }

            setEmployeeCreationData(prev => ({
                ...prev,
                [fieldName]: ['gender', 'qualification', 'interviewDoneBy'].includes(fieldName)
                    ? (value ? Number(value) : '')
                    : value,
            }));

            setErrors(prev => ({
                ...prev,
                [fieldName]: '',
            }));

            if (fieldName === 'qualification') {
                setSelectedQualification(value);
            } else if (fieldName === 'interviewDoneBy') {
                setSelectedUserId(value);
            } else if (fieldName === 'designations') {
                setSelectedDesignation(value);
                setEmployeeCreationData((prev) => ({
                    ...prev,
                    jobPosition: value,
                }));
            }
        }
    };

    const validateForm = () => {
        let formErrors = {};
        let isValid = true;

        if (!employeeCreationData.firstName?.trim()) {
            formErrors.firstName = "Surname is required";
            isValid = false;
        }

        if (!employeeCreationData.lastName?.trim()) {
            formErrors.lastName = "Employee Name is required";
            isValid = false;
        }

        if (!employeeCreationData.dateOfBirth) {
            formErrors.dateOfBirth = "Date of Birth is required";
            isValid = false;
        } else {
            if (!validateAge(employeeCreationData.dateOfBirth, 18)) {
                formErrors.dateOfBirth = "Employee must be at least 18 years old.";
                isValid = false;
            } else if (!validatePastDate(employeeCreationData.dateOfBirth)) {
                formErrors.dateOfBirth = "Date of Birth cannot be in the future.";
                isValid = false;
            }
        }

        if (!employeeCreationData.contactNumber) {
            formErrors.contactNumber = 'Contact Number is required';
            isValid = false;
        } else if (!validateMobile(employeeCreationData.contactNumber)) {
            formErrors.contactNumber = 'Contact Number must start with 6, 7, 8, or 9 and be 10 digits long';
            isValid = false;
        }


        if (!employeeCreationData.emailAddress) {
            formErrors.emailAddress = "Email Address is required";
            isValid = false;
        } else if (!validateEmail(employeeCreationData.emailAddress)) {
            formErrors.emailAddress = "Invalid email format";
            isValid = false;
        }

        if (!employeeCreationData.jobPosition) {
            formErrors.jobPosition = "Job Position is required";
            isValid = false;
        }

        if (!employeeCreationData.qualification) {
            formErrors.qualification = "Qualification is required";
            isValid = false;
        }

        if (!employeeCreationData.interviewDoneBy) {
            formErrors.interviewDoneBy = "Interview Done By is required";
            isValid = false;
        }

        if (!employeeCreationData.interviewDate) {
            formErrors.interviewDate = "Interview Date is required";
            isValid = false;
        } else if (!validatePastDate(employeeCreationData.interviewDate)) {
            formErrors.interviewDate = "Interview Date cannot be in the future.";
            isValid = false;
        }

        if (!employeeCreationData.aadharNumber) {
            formErrors.aadharNumber = "Aadhaar Number is required";
            isValid = false;
        } else if (!validateAadhaar(employeeCreationData.aadharNumber)) {
            formErrors.aadharNumber = "Aadhaar Number must be a 12-digit number";
            isValid = false;
        }

        setErrors(formErrors);
        return isValid;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validateForm()) return;

        const fullName = localStorage.getItem("full_name");
        const role = localStorage.getItem("role");
        const employeeId = localStorage.getItem("employeeId");

        const payload = {
            employee: {
                firstName: employeeCreationData.firstName,
                lastName: employeeCreationData.lastName,
                gender: { id: Number(employeeCreationData.gender) },
                dob: employeeCreationData.dateOfBirth,
                jobPosition: { id: Number(employeeCreationData.jobPosition) },
                qualification: { id: Number(employeeCreationData.qualification) },
                mobile: employeeCreationData.contactNumber,
                email: employeeCreationData.emailAddress,
                yearsOfExperience: employeeCreationData.yearsOfExp,
                interviewDoneBy: { employeeloginId: Number(employeeCreationData.interviewDoneBy) },
                interviewCompletedDate: employeeCreationData.interviewDate,
                aadhaarNumber: employeeCreationData.aadharNumber,
            },
            auditLog: { name: fullName, role, employeeId },
        };

        try {
            setLoading(true);
            let response;

            if (isEditMode) {
                response = await updateEmployee(employeeToEdit.id, payload);
                setSuccessMessage("Employee data updated successfully.");
            } else {
                response = await createEmployee(payload);
                setSuccessMessage("Employee created successfully!");
            }

            setSaveResponse(response.data.employeeUniqueId);
            setApiError("");
            setErrors({});
            setShowSaveSuccess(true);
            setShowDialog(true);
            setIsSaved(true);

            if (isEditMode) {
                setInitialData(employeeCreationData);
                setHasChanges(false);
            }

            setTimeout(() => setShowSaveSuccess(false), 5000);

        } catch (error) {
            console.error("Failed to submit data:", error);
            let newErrors = { ...errors };

            // Reset error messages first to clear any existing error states
            setMobileNumberError('');
            setEmailError('');
            setAadharNumberError('');

            // Check if the error response contains a structured error
            // Check if error response has structured errors
            if (error.response?.data) {
                const errData = error.response.data;

                // Handle individual field errors
                if (errData.emailError) {
                    newErrors.emailAddress = errData.emailError;
                    setEmailError(errData.emailError);
                }
                if (errData.contactError) {
                    newErrors.contactNumber = errData.contactError;
                    setMobileNumberError(errData.contactError);
                }
                if (errData.aadhaarError) {
                    newErrors.aadharNumber = errData.aadhaarError;
                    setAadharNumberError(errData.aadhaarError);
                }

                // Optional: fallback general error
                if (!errData.emailError && !errData.contactError && !errData.aadhaarError) {
                    setApiError("Something went wrong. Please try again.");
                }
            } else {
                setApiError("Something went wrong. Please try again.");
            }

            setErrors(newErrors);
        } finally {
            setLoading(false);
        }

    };


    const handleCancel = () => {
        Navigate('/dashboard');
    };

    const handleClear = () => {
        setEmployeeCreationData({
            firstName: "",
            lastName: "",
            gender: "",
            dateOfBirth: "",
            contactNumber: "",
            emailAddress: "",
            jobPosition: "",
            yearsOfExp: "",
            aadharNumber: "",
            qualification: "",
            interviewDoneBy: "",
            interviewDate: "",
        });
        setSelectedQualification(null);
        setSelectedDesignation(null);
        setSelectedUserId(null);
        setIsSaved(false);
        setSuccessMessage("");
        setShowSaveSuccess(false);
        setErrors({});
        setApiError('');
    };

    const handleDialogClose = () => {
        setShowDialog(false);
        handleClear();
        if (isEditMode) {
            Navigate('/employeeApplications/draft');
        }
    };

    const dateInputRef = useRef(null);

    const handleDateInputClick = () => {
        dateInputRef.current?.showPicker();
    };

    // const capitalizeFirstLetter = (str) => {
    //     if (!str) return "";
    //     return str
    //         .split(" ")
    //         .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    //         .join(" ");
    // };

    return (
        <React.Fragment>
            <div className="employees-container">
                <div className="employees-box">
                    <h2 className="employees-heading">
                        {employeeToEdit
                            ? `Update Employee: ${employeeToEdit.firstName} ${employeeToEdit.lastName} ${employeeToEdit.employeeUniqueId}`
                            : "Employee Creation Form"}
                    </h2>

                    <form onSubmit={handleSubmit}>
                        <div className="employees-maincontainer">

                            <div className="employees-container-part">
                                <div className="employees-floating-label-container-1">
                                    <input
                                        type="text"
                                        name="firstName"
                                        value={employeeCreationData.firstName}
                                        onChange={(e) => {
                                            let value = e.target.value;
                                            if (/^[a-zA-Z\s]*$/.test(value)) {
                                                const updatedValue = capitalizeFirstLetter(value);
                                                handleInputChange({
                                                    target: {
                                                        name: "firstName",
                                                        value: updatedValue
                                                    }
                                                });
                                            }
                                        }}
                                        placeholder=" "
                                        required
                                    />
                                    <label><span className="required">*</span>Given Name</label>
                                    {errors.firstName && <p className="error">{errors.firstName}</p>}
                                </div>
                            </div>
                            <div className="employees-container-part">
                                <div className="employees-floating-label-container-2">
                                    <input
                                        type="text"
                                        name="lastName"
                                        value={employeeCreationData.lastName}
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            if (/^[a-zA-Z\s]*$/.test(value)) {
                                                const updatedValue = capitalizeFirstLetter(value);
                                                handleInputChange({
                                                    target: {
                                                        name: "lastName",
                                                        value: updatedValue
                                                    }
                                                });
                                            }
                                        }}
                                        placeholder=" "
                                        required
                                    />
                                    <label><span className="required">*</span>Surname</label>
                                    {errors.lastName && <p className="error">{errors.lastName}</p>}
                                </div>
                            </div>
                        </div>
                        <div className="employees-maincontainer">
                            <div className="employees-container-part">
                                <div className={`employees-floating-label-container-2 ${isFocused.gender || !!employeeCreationData.gender ? 'float-label' : ''}`}>
                                    <Select
                                        name="gender"
                                        options={genders}
                                        value={genders.find(opt => opt.value === employeeCreationData.gender) || null}
                                        onChange={(selectedOption) => handleInputChange(selectedOption, 'gender')}
                                        onFocus={() => setIsFocused(prev => ({ ...prev, gender: true }))}
                                        onBlur={() => setIsFocused(prev => ({ ...prev, gender: false }))}
                                        placeholder=" "
                                        isClearable
                                        onInputChange={(newValue) => {
                                            // Validate that only alphabetic characters and spaces are allowed
                                            const isValid = /^[A-Za-z\s]*$/.test(newValue);
                                            if (!isValid) {
                                                // Optionally, you can show an error message or prevent input here
                                                return ""; // Prevent invalid characters
                                            }
                                            return newValue; // Allow input if valid
                                        }}
                                        // styles={{
                                        //     menuPortal: base => ({ ...base, zIndex: 9999, position: 'absolute', top: 'auto', bottom: '100%' }),
                                        //     menu: base => ({ ...base, marginTop: '5px', zIndex: 9999 }),
                                        //     control: provided => ({ ...provided, padding: '1px' }),
                                        //     valueContainer: provided => ({ ...provided, padding: '3px 6px' }),
                                        // }}
                                        styles={selectStyles}
                                    />

                                    <label><span className="required">*</span>Gender</label>
                                    {errors.gender && <p className="error">{errors.gender}</p>}
                                </div>
                            </div>
                            <div className="employees-container-part">
                                <div className={`employees-floating-label-container-2 ${isFocused.dateOfBirth || !!employeeCreationData.dateOfBirth ? 'float-label' : ''}`}>
                                    <DatePicker
                                        selected={employeeCreationData.dateOfBirth ? new Date(employeeCreationData.dateOfBirth) : null}
                                        onChange={(date) => {
                                            if (date) {
                                                const localDate = new Date(date);
                                                localDate.setHours(0, 0, 0, 0);
                                                const formatted = localDate.toLocaleDateString('en-CA');
                                                handleInputChange({ target: { name: 'dateOfBirth', value: formatted } });
                                            } else {
                                                handleInputChange({ target: { name: 'dateOfBirth', value: '' } });
                                            }
                                        }}
                                        dateFormat="dd-MM-yyyy"
                                        placeholderText="dd-MM-yyyy"
                                        className="did-floating-input"
                                        onFocus={() => setIsFocused(prev => ({ ...prev, dateOfBirth: true }))}
                                        onBlur={() => setIsFocused(prev => ({ ...prev, dateOfBirth: false }))}
                                        ref={dateInputRef}
                                        minDate={new Date(minDate)}
                                        maxDate={new Date(maxDOB)} // Restrict to 18 years ago
                                        showYearDropdown
                                        scrollableYearDropdown
                                        yearDropdownItemNumber={35}
                                    />
                                    <label><span className="required">*</span>Date of Birth</label>
                                    {errors.dateOfBirth && <p className="error">{errors.dateOfBirth}</p>}
                                </div>
                            </div>
                        </div>
                        <div className="employees-maincontainer">
                            <div className="employees-container-part">
                                <div className="employees-floating-label-container-1">
                                    <input
                                        type="text"
                                        name="contactNumber"
                                        value={employeeCreationData.contactNumber}
                                        onChange={(e) => {
                                            const value = e.target.value;

                                            // Allow only digits up to 10
                                            if (/^\d{0,10}$/.test(value)) {
                                                handleInputChange(e);

                                                // Live validation for mobile number
                                                if (value.length === 10 && !validateMobile(value)) {
                                                    setErrors((prev) => ({
                                                        ...prev,
                                                        contactNumber: "Mobile number must start with 6, 7, 8, or 9",
                                                    }));
                                                } else {
                                                    // Clear error if valid or incomplete
                                                    setMobileNumberError('');
                                                }
                                            }
                                        }}
                                        required
                                        placeholder=" "
                                        maxLength="10"
                                        pattern="^[0-9]{10}$"
                                        title="Please enter a valid 10-digit phone number."
                                    />
                                    <label><span className="required">*</span>Contact Number</label>
                                    {mobileNumberError && <p className="error">{mobileNumberError}</p>}
                                </div>
                            </div>
                            <div className="employees-container-part">
                                <div className="employees-floating-label-container-1">
                                    <input
                                        type="email"
                                        name="emailAddress"
                                        value={employeeCreationData.emailAddress}
                                        onChange={(e) => {
                                            handleInputChange(e);
                                            setEmailError(''); // CLEAR API ERROR
                                        }}
                                        required
                                        placeholder=" "
                                    />
                                    <label><span className="required">*</span>Email</label>
                                    {emailError && <p className="error">{emailError}</p>}
                                </div>
                            </div>
                        </div>
                        <div className="employees-maincontainer">
                            <div className="employees-container-part">
                                <div className={`employees-floating-label-container-1 ${selectedDesignation ? 'filled' : ''}`}>
                                    <Select
                                        options={designations}
                                        value={designations.find((option) => option.value === employeeCreationData.jobPosition) || null}
                                        onChange={(selectedOption) => handleInputChange(selectedOption, 'designations')}
                                        placeholder=""
                                        isClearable
                                        menuPortalTarget={document.body}
                                        // styles={{
                                        //     menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        //     control: (provided) => ({
                                        //         ...provided,
                                        //         backgroundColor: "#fff",
                                        //         borderColor: "#c9c9c9",
                                        //     }),
                                        //     singleValue: (provided) => ({ ...provided, color: "#474747" }),
                                        // }}
                                        styles={selectStyles}
                                    />
                                    <label><span className="required">*</span>Job Position</label>
                                    {errors.jobPosition && <p className="error">{errors.jobPosition}</p>}
                                </div>
                            </div>
                            <div className="employees-container-part">
                                <div className={`employees-floating-label-container-1 ${selectedQualification ? 'filled' : ''}`}>
                                    <Select
                                        options={qualifications}
                                        value={qualifications.find((option) => option.value === employeeCreationData.qualification) || null}
                                        onChange={(selectedOption) => handleInputChange(selectedOption, 'qualification')}
                                        placeholder=""
                                        isClearable
                                        menuPortalTarget={document.body}
                                        // styles={{
                                        //     menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        //     control: (provided) => ({
                                        //         ...provided,
                                        //         backgroundColor: "#fff",
                                        //         borderColor: "#c9c9c9",
                                        //     }),
                                        //     singleValue: (provided) => ({ ...provided, color: "#474747" }),
                                        // }}
                                        styles={selectStyles}
                                    />
                                    <label><span className="required">*</span>Qualification</label>
                                    {errors.qualification && <p className="error">{errors.qualification}</p>}
                                </div>
                            </div>
                        </div>
                        <div className="employees-maincontainer">
                            <div className="employees-container-part">
                                <div className="employees-floating-label-container-1">
                                    <input
                                        type="text"
                                        name="yearsOfExp"
                                        value={employeeCreationData.yearsOfExp}
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            if (/^\d{0,2}$/.test(value)) {
                                                handleInputChange(e);
                                            }
                                        }}
                                        required
                                        placeholder=" "
                                        maxLength="2"
                                        pattern="\d{1,2}"
                                        title="Please enter a valid number of years (1 or 2 digits)."
                                    />
                                    <label><span className="required">*</span>Year of Experience</label>
                                    {errors.yearsOfExp && <p className="error">{errors.yearsOfExp}</p>}
                                </div>
                            </div>
                            <div className="employees-container-part">
                                <div className={`employees-floating-label-container-1 ${selectedUserId ? 'filled' : ''}`}>
                                    <Select
                                        options={users}
                                        value={users.find((option) => option.value === employeeCreationData.interviewDoneBy) || null}
                                        onChange={(selectedOption) => handleInputChange(selectedOption, 'interviewDoneBy')}
                                        isClearable
                                        placeholder="Select user"
                                        menuPortalTarget={document.body}
                                        // styles={{
                                        //     menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        //     control: (provided) => ({
                                        //         ...provided,
                                        //         backgroundColor: "#fff",
                                        //         borderColor: "#c9c9c9",
                                        //     }),
                                        //     singleValue: (provided) => ({ ...provided, color: "#474747" }),
                                        // }}
                                        styles={selectStyles}
                                    />
                                    <label><span className="required">*</span>Interview Done By</label>
                                    {errors.interviewDoneBy && <p className="error">{errors.interviewDoneBy}</p>}
                                </div>
                            </div>
                        </div>
                        <div className="employees-maincontainer">
                            <div className="employees-container-part">
                                <div className={`employees-floating-label-container-2 ${isFocused.interviewDate || !!employeeCreationData.interviewDate ? 'float-label' : ''}`}>
                                    <DatePicker
                                        selected={employeeCreationData.interviewDate ? new Date(employeeCreationData.interviewDate) : null}
                                        onChange={(date) => {
                                            if (date) {
                                                const localDate = new Date(date);
                                                localDate.setHours(0, 0, 0, 0);
                                                const formatted = localDate.toLocaleDateString('en-CA');
                                                handleInputChange({ target: { name: 'interviewDate', value: formatted } });
                                            } else {
                                                handleInputChange({ target: { name: 'interviewDate', value: '' } });
                                            }
                                        }}
                                        dateFormat="dd-MM-yyyy"
                                        placeholderText="dd-MM-yyyy"
                                        className="did-floating-input"
                                        onFocus={() => setIsFocused(prev => ({ ...prev, interviewDate: true }))}
                                        onBlur={() => setIsFocused(prev => ({ ...prev, interviewDate: false }))}
                                        ref={dateInputRef}
                                        minDate={new Date(minDate)}
                                        maxDate={new Date(maxDate)}
                                    />
                                    <label><span className="required">*</span>Interview Date</label>
                                    {errors.interviewDate && <p className="error">{errors.interviewDate}</p>}
                                </div>
                            </div>
                            <div className="employees-container-part">
                                <div className="employees-floating-label-container-1">
                                    <input
                                        type="text"
                                        name="aadharNumber"
                                        value={employeeCreationData.aadharNumber}
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            if (/^\d{0,12}$/.test(value)) {
                                                handleInputChange(e);
                                                setAadharNumberError('');
                                            }
                                        }}
                                        required
                                        placeholder=" "
                                        maxLength="12"
                                        pattern="\d{12}"
                                        title="Please enter a valid 12-digit Aadhaar number."
                                    />
                                    <label><span className="required">*</span>Aadhaar Number</label>
                                    {aadharNumberError && <p className="error">{aadharNumberError}</p>}
                                </div>
                            </div>
                        </div>

                        <div className="employees-btn-div">
                            <button type="button" className="employees-cancel" onClick={handleCancel}>
                                Close
                            </button>
                            <button type="button" className="employees-clear" onClick={handleClear}>
                                Clear
                            </button>
                            {!isSaved && (
                                <button
                                    type="submit"
                                    className="employees-btn"
                                    disabled={!isFormValid || loading || (isEditMode && !hasChanges)}
                                >
                                    {loading
                                        ? isEditMode
                                            ? "Updating..."
                                            : "Saving..."
                                        : isEditMode
                                            ? "Update"
                                            : "Save"}
                                </button>
                            )}
                        </div>
                        {showSaveSuccess && (
                            <div className="confirm-overlay">
                                <div className="success-message-popup">
                                    {`${successMessage} Temporary ID: ${savedResponse}`}
                                </div>
                            </div>
                        )}
                        {showDialog && (
                            <div className="confirm-overlay">
                                <div className="success-message-popup">
                                    <h3>{`${successMessage} Temporary ID: ${savedResponse}`}</h3>
                                    <button onClick={handleDialogClose} className="dialog-ok-btn">
                                        OK
                                    </button>
                                </div>
                            </div>
                        )}
                    </form>
                </div>
            </div>
        </React.Fragment>
    );
};

export default EmployeeCreationForm;